export default __webpack_public_path__ + "static/108090-42c43ac3a41ad3700c2b8356fb44ec0f.jpg";